import { useState } from "react";

const NotificationBanner = ({ showClose = false, text }) => {
  const [visible] = useState(false);

  if (visible) return null;

  return (
    <div className={`banner-message ${visible ? "visible" : ""}`}>
      <div className="banner-message-content">
        {text}
      </div>
      {showClose && (
        <button className="banner-message-close" onClick={setVisible(false)}>
          ✖
        </button>
      )}
    </div>
  );
};

export default NotificationBanner;
